<template>
   <div class="padded">

     <files-panel title="Site Attachments" :id="rowData.id" type="site" :read-only="readOnly" />

   </div>
</template>

<script>

import FilesPanel from '@/components/atoms/files/FilesPanel'

export default {
  components: {
    FilesPanel
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      localData: this.rowData
    }
  }
}

</script>
